module.exports = __webpack_public_path__ + "media/icon/icon-todo-0f52fbd4.svg";